import { render } from "./DiscountPrice.vue?vue&type=template&id=25a6f314&scoped=true"
import script from "./DiscountPrice.vue?vue&type=script&lang=js"
export * from "./DiscountPrice.vue?vue&type=script&lang=js"

import "./DiscountPrice.vue?vue&type=style&index=0&id=25a6f314&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a6f314"]])

export default __exports__